<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7">
          <corporation-edit-form v-if="corporation" :corporation="corporation">
          </corporation-edit-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import CorporationEditForm from './Corporations/CorporationEditForm.vue'

  export default {
    mounted() {
      const self = this
      self.$store.dispatch("Corporation/requestCorporationShow", self.$route.params.id).then((corporation)=> {
        self.corporation = corporation
      })
    },
    components: {
      CorporationEditForm,
    },
    data(){
      return {
        corporation: null,
      }
    },
  }

</script>
<style>

</style>
